export default __webpack_public_path__ + "static/media/course1.1c416864.png";